import { defineComponent as _defineComponent } from 'vue'
import useTruncation from '@/composables/useTruncation'
import { Icons } from '@/icons/icons'
import { Note } from './ExpedientReminderNotesComponentTypes'
import { PropType } from 'vue/types/v3-component-props'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'ReminderNoteComponent',
  props: {
  note: {
    type: Object as PropType<Note>,
    required: true
  }
},
  emits: ['edit-note', 'show-remove-dialog'],
  setup(__props, { emit }) {

const { note } = __props;



const icons = {
  note: Icons.TASKS,
  remove: Icons.REMOVE
}

// COMPOSABLES
const { checkElementTruncation, elementRef, isTruncated } = useTruncation()

// EVENTS


// METHODS
function editNote(note: Note) {
  emit('edit-note', note)
}

function showRemoveDialog(note: Note) {
  emit('show-remove-dialog', note)
}

return { __sfc: true,icons, checkElementTruncation, elementRef, isTruncated, emit, editNote, showRemoveDialog, LexonTooltipComponent }
}

})